export const colors = {
	brown: {
		primary: "#9E292B",
		light: "#401819",
	},
	red: {
		error: "#cc0000",
	},
	green: {
		success: "#488155",
	},
	orange: {
		warning: "#ff7400",
	},
	gray: {
		lighter: "#CBD2E0",
		light: "#a9a9a9",
		normal_disabled: "#717D96",
		info_dark: "#3d3d3d",
		info_darker: "#262626",
	},
	black: {
		info: "#000000",
	},
	white: {
		background: "#ffffff",
		paper: "#f1f1f1",
		dark: "#EAEAEA",
		darker: "#D9D9D9",
	},
};
